import { AxiosRequestConfig } from 'axios';
import { AxiosHttpClient } from './AxiosHttpClient';
import { WithRequestId } from './WithRequestId';

export const createHttpClient = (apiUrl: string, config?: AxiosRequestConfig) => {
  return new WithRequestId(new AxiosHttpClient(apiUrl, config));
};
